// assets/js/sliders/shader-carousel.js
import {
  SplideShaderCarousel,
  maskShader,
  dissolveShader,
} from '@splidejs/splide-shader-carousel';

export function initShaderHeroCarousels() {
  const elements = document.querySelectorAll('.js-splide-shader');
  if (!elements.length) return;

  if (!SplideShaderCarousel.isAvailable()) {
    // TODO: fallback Splide normal si nécessaire
    return;
  }

  elements.forEach((el) => {
    // Anti double-mount
    if (el.dataset.splideMounted === '1') return;
    el.dataset.splideMounted = '1';

    const parent = el.closest('[data-shader-type]');
    if (!parent) return;

    const shaderType = parent.dataset.shaderType || 'mask';
    const mask = parent.dataset.shaderMask || '';
    const height = parseInt(parent.dataset.shaderHeight || '600', 10);
    const intensity = parseFloat(parent.dataset.shaderIntensity || '0.5');
    const uvX = parseFloat(parent.dataset.shaderUvX || '1');
    const uvY = parseFloat(parent.dataset.shaderUvY || '1');

    const shader = shaderType === 'dissolve' ? dissolveShader : maskShader;

    const splide = new SplideShaderCarousel(el, shader, {
      type: 'fade',
      height,
      rewind: true,
      continuous: true,
      pagination: false,
      arrows: true,

      // Transition
      speed: 1000,
      easing: 'cubic-bezier(0.25, 1, 0.5, 1)',

      // Autoplay (rythme “hero”)
      autoplay: true,
      interval: 5500,
      pauseOnHover: true,
      pauseOnFocus: true,

      ...(shaderType === 'mask' ? { mask } : {}),
      material: {
        intensity,
        uvOffset: [uvX, uvY],
      },

      awaitInit: true,
      preDecoding: 'nearby',
    });

    splide.mountAsync().catch(() => {
      // silencieux en prod
    });
  });
}

document.addEventListener('DOMContentLoaded', initShaderHeroCarousels, { once: true });
